import { Button } from '@mui/material';
import { EditIcon } from '@diligentcorp/atlas-react-icons';
import { useTranslation } from 'react-i18next';

export type SLAsGridToolbarEditSLAProps = {
  onEditSLAClick: () => void;
};

export function SLAsGridToolbarEditSLA(props: SLAsGridToolbarEditSLAProps) {
  const { onEditSLAClick } = props;
  const { t } = useTranslation('settings');

  return (
    <Button
      onClick={onEditSLAClick}
      variant='text'
      startIcon={<EditIcon />}
      data-testid='edit-sla-button'
    >
      {t('slaConfiguration.edit')}
    </Button>
  );
}
